/*
  kvd-card-actions.js
  Warenkorb-Icon und Groessen-Auswahl auf den Produktkarten (snippets/product-card.liquid).
  Wird einmal in layout/theme.liquid geladen - frueher lief dieses Skript pro Karte.
*/
(function () {
  if (window.__kvdCardActions) return;
  window.__kvdCardActions = true;

  function kvdOpenCartDrawer(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function (item) {
        if (item.status) { console.error('Cart add error:', item); return; }
        return fetch('/cart?sections=cart-drawer,cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var cartDrawer = document.querySelector('cart-drawer');
            if (!cartDrawer) return;

            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl && sections['cart-icon-bubble']) {
              var bp = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var bs = bp.querySelector('.shopify-section');
              if (bs) bubbleEl.innerHTML = bs.innerHTML;
            }

            var cartDrawerEl = document.getElementById('CartDrawer');
            if (cartDrawerEl && sections['cart-drawer']) {
              var dp = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
              var ds = dp.querySelector('#CartDrawer');
              if (ds) cartDrawerEl.innerHTML = ds.innerHTML;
            }

            var drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');
            cartDrawer.classList.remove('is-empty');

            var checkoutBtn = cartDrawer.querySelector('#CartDrawer-Checkout');
            if (checkoutBtn) {
              checkoutBtn.removeAttribute('disabled');
              checkoutBtn.addEventListener('click', function (e) {
                e.preventDefault();
                window.location.href = '/checkout';
              });
            }

            var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer, false));

            setTimeout(function () { cartDrawer.open(); }, 0);
          });
      })
      .catch(function (err) { console.error('Cart error:', err); });
  }

  // Lagerzeile der Kachel an die gewaehlte Groesse anpassen: Menge dieser Groesse / im Store / nicht vorraetig
  function kvdUpdateStock(option, state) {
    var card = option.closest('.card-wrapper') || option.closest('.card');
    var stock = card ? card.querySelector('.kvd-card-stock') : null;
    if (!stock || stock.classList.contains('kvd-card-stock--testbike')) return;
    var cls, text;
    if (state === 'online') {
      var qty = parseInt(option.dataset.qty, 10);
      if (qty > 0 && qty <= 2) {
        cls = 'kvd-card-stock kvd-card-stock--low'; text = 'Nur noch ' + qty + ' übrig';
      } else {
        cls = 'kvd-card-stock kvd-card-stock--online'; text = 'Vorrätig';
      }
    } else if (state === 'store') {
      var t = option.getAttribute('title') || '';
      cls = 'kvd-card-stock kvd-card-stock--store';
      text = t.replace(/^Nur im Store:\s*/, '') || 'Nur im Store';
    } else {
      cls = 'kvd-card-stock kvd-card-stock--out'; text = 'Nicht vorrätig';
    }
    stock.className = cls;
    stock.textContent = '';
    var dot = document.createElement('span');
    dot.className = 'kvd-card-stock__dot';
    stock.appendChild(dot);
    stock.appendChild(document.createTextNode(text.trim()));
  }

  function initCustomSelects() {
    document.querySelectorAll('.card__variant-custom-select:not([data-initialized])').forEach(function (select) {
      select.dataset.initialized = 'true';
      var selected = select.querySelector('.card__variant-selected');
      if (!selected) return;
      // Beim Laden: Lagerzeile auf die vorausgewaehlte Groesse setzen
      var initForm = select.closest('form');
      var initId = initForm ? initForm.querySelector('.product-variant-id') : null;
      var initOpt = initId ? select.querySelector('.card__variant-option[data-value="' + initId.value + '"]') : null;
      if (initOpt) kvdUpdateStock(initOpt, initOpt.dataset.state || 'online');
      selected.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault();
        document.querySelectorAll('.card__variant-custom-select.open').forEach(function (el) { if (el !== select) el.classList.remove('open'); });
        select.classList.toggle('open');
        // Beim Oeffnen zur gewaehlten Groesse scrollen
        if (select.classList.contains('open')) {
          var list = select.querySelector('.card__variant-options');
          var form = select.closest('form');
          var current = form ? form.querySelector('.product-variant-id') : null;
          var active = current ? list.querySelector('.card__variant-option[data-value="' + current.value + '"]') : null;
          if (list && active) {
            list.scrollTop = Math.max(0, active.offsetTop - (list.clientHeight - active.offsetHeight) / 2);
          }
        }
      });
      select.querySelectorAll('.card__variant-option').forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.stopPropagation(); e.preventDefault();
          var label = selected.querySelector('.kvd-size-label') || selected;
          label.textContent = this.dataset.title || this.textContent;
          var state = this.dataset.state || 'online';
          selected.dataset.state = state;
          kvdUpdateStock(this, state);
          select.classList.remove('open');
          var form = select.closest('form');
          if (form) {
            form.querySelector('.product-variant-id').value = this.dataset.value;
            // Warenkorb nur fuer online verfuegbare Groessen
            var cartBtn = form.querySelector('.card__atc-icon-btn');
            if (cartBtn) {
              cartBtn.disabled = state !== 'online';
              cartBtn.title = state === 'store' ? 'Nur im Store erhältlich' : (state === 'out' ? 'Nicht vorrätig' : '');
            }
          }
        });
      });
    });
  }

  function initDirectAddButtons() {
    document.querySelectorAll('.card__atc-icon-btn[data-variant-id]:not([data-initialized])').forEach(function (btn) {
      btn.dataset.initialized = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        kvdOpenCartDrawer(this.dataset.variantId);
      });
    });
  }

  function initCardSubmitButtons() {
    document.querySelectorAll('product-form.card__atc-row .form:not([data-initialized])').forEach(function (form) {
      form.dataset.initialized = 'true';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = form.querySelector('.product-variant-id').value;
        if (!variantId) return;
        kvdOpenCartDrawer(variantId);
      });
    });
  }

  function initAll() {
    initCustomSelects();
    initDirectAddButtons();
    initCardSubmitButtons();
  }

  document.addEventListener('click', function () {
    document.querySelectorAll('.card__variant-custom-select.open').forEach(function (el) { el.classList.remove('open'); });
  });

  // Neue Karten (Filter, Nachladen, Suche) werden gebuendelt einmal pro Frame initialisiert.
  var scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  }

  function start() {
    initAll();
    new MutationObserver(scheduleInit).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* KvD: Upsell-App (Selleasy) - mittlere Groesse vorwaehlen (M, sonst L) statt der ersten Option */
(function () {
  if (window.__kvdLbDefault) return;
  window.__kvdLbDefault = true;
  var PREF = ['M', 'L'];
  function sizeOf(text) {
    var parts = String(text).split('/');
    return parts[parts.length - 1].trim().toUpperCase();
  }
  function apply(sel) {
    if (sel.dataset.kvdDefault) return;
    var host = sel.closest('lb-variant-picker');
    if (host && !host.classList.contains('hydrated')) return; /* erst wenn die App bereit ist, sonst landet die falsche Groesse im Warenkorb */
    if (!sel.options.length) return; /* Optionen kommen erst nach dem Laden */
    sel.dataset.kvdDefault = '1';
    if (sel.selectedIndex > 0) return;
    var opts = Array.prototype.slice.call(sel.options);
    for (var i = 0; i < PREF.length; i++) {
      for (var j = 0; j < opts.length; j++) {
        var o = opts[j];
        if (!o.disabled && sizeOf(o.text) === PREF[i]) {
          setTo(sel, o.value, 3);
          return;
        }
      }
    }
  }
  function setTo(sel, value, tries) {
    sel.value = value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    /* falls die App kurz danach neu zeichnet und zuruecksetzt: nochmal */
    setTimeout(function () {
      if (sel.isConnected && sel.value !== value && sel.selectedIndex === 0 && tries > 1) setTo(sel, value, tries - 1);
    }, 600);
  }
  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('select.lb-variant-picker:not([data-kvd-default])').forEach(apply);
  }
  function queue() {
    if (!queued) { queued = true; requestAnimationFrame(scan); }
  }
  function start() {
    scan();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
